import React from 'react';
import { Calendar } from 'lucide-react';

export default function DepartmentUpdates() {
  return (
    <div className="space-y-4 bg-white rounded-lg p-6 border border-gray-100">
      <div className="border-b border-gray-100 pb-4">
        <h3 className="text-sm font-medium text-gray-900 mb-2">Development Department</h3>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div className="bg-blue-500 h-2 rounded-full" style={{ width: '60%' }} />
        </div>
        <p className="text-sm text-gray-600 mt-2">
          • Vision workshop in progress<br />
          • Brand identity development started<br />
          • 2 high-priority tasks pending review
        </p>
      </div>

      <div className="border-b border-gray-100 pb-4">
        <h3 className="text-sm font-medium text-gray-900 mb-2">Operations Department</h3>
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div className="bg-green-500 h-2 rounded-full" style={{ width: '40%' }} />
        </div>
        <p className="text-sm text-gray-600 mt-2">
          • Initial setup completed<br />
          • Process documentation in progress<br />
          • Workflow optimization scheduled
        </p>
      </div>

      <div>
        <h3 className="text-sm font-medium text-gray-900 mb-2">Upcoming Milestones</h3>
        <ul className="text-sm text-gray-600 space-y-2">
          <li className="flex items-center space-x-2">
            <Calendar className="w-4 h-4 text-blue-500" />
            <span>Vision Workshop Completion - March 25</span>
          </li>
          <li className="flex items-center space-x-2">
            <Calendar className="w-4 h-4 text-blue-500" />
            <span>Operations Review Meeting - March 28</span>
          </li>
        </ul>
      </div>
    </div>
  );
}